import { render, staticRenderFns } from "./ResearchPlan.vue?vue&type=template&id=4d6ef57a&"
import script from "./ResearchPlan.vue?vue&type=script&lang=js&"
export * from "./ResearchPlan.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports